<template>
    <VerificationContent :indentation-level="0">
        <VerificationGrid
            class="text-sm"
            :grid-cols="4"
            :indentation-level="0"
        >
            <CheckTextualResult
                :colorful-state="true"
                label="Account standing:"
                :value="accountStanding"
            />
            <CheckTextualResult
                label="Account Open Date:"
                :value="
                    makeCheckResult({
                        state: CheckResultState.NotApplicable,
                        text: accountStatus.open_date || 'N/A',
                    })
                "
            />
            <CheckTextualResult
                label="Account last updated:"
                :value="
                    makeCheckResult({
                        state: CheckResultState.NotApplicable,
                        text: accountStatus.last_update || 'Unknown',
                    })
                "
            />
        </VerificationGrid>
    </VerificationContent>
</template>

<script lang="ts" setup>
import type { AccountStatus } from '@/api/interfaces/bank-account-verification.api';
import { AccountStatusStanding } from '@/api/interfaces/bank-account-verification.api';
import type { CheckResult } from '@/api/interfaces/identity-verification-report.api';
import { CheckResultState } from '@/api/interfaces/identity-verification-report.api';
import { makeCheckResult } from '@/components/Components/BankAccountVerification/report-check-result-mapping';
import { computed } from 'vue';
import CheckTextualResult from '../../IdentityVerificationReport/common/CheckTextualResult.vue';
import VerificationContent from '../../IdentityVerificationReport/common/VerificationContent.vue';
import VerificationGrid from '../../IdentityVerificationReport/common/VerificationGrid.vue';

const props = defineProps<{ accountStatus: AccountStatus }>();

const accountStanding = computed<CheckResult>(() => {
    const standing = props.accountStatus?.standing;
    return makeCheckResult({
        state: standing === AccountStatusStanding.valid ? CheckResultState.Passed : CheckResultState.Failed,
        stateText: standing,
    });
});
</script>
